import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { loginWithToken } from 'api/tfa-api';
import { createAlert } from 'services/alert-service';

import FieldDefault from 'components/field-default';

const LoginAdditionalAuth = ({ additionalAuth, email, password, onSuccess }) => {
    const { t } = useTranslation(['onboarding', 'settings']);
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState('');

    const submit = useCallback(async () => {
        setLoading(true);
        try {
            const response = await loginWithToken({ token, email, password });
            onSuccess({
                masterToken: response.master_token,
                teamTokens: response.team_tokens
            });
        } catch (e) {
            createAlert('error', e);
        }
        setLoading(false);
    }, [token, email, password, onSuccess]);

    return (
        <div className="section-login">
            <div className="section-head">
                <h1>{ t('loginTitle') }</h1>
            </div>

            <div className="section-body">
                <div className="form">
                    <div className="form-row">
                        <FieldDefault type="number" label={ t('settings:tfa.tokenLabel') } placeholder={ t('settings:tfa.tokenPlaceholder') } onChange={setToken} />
                    </div>
                </div>
            </div>

            <div className="section-foot">
                <button className={'btn btn-block btn-success btn-has-loading' + (loading ? ' loading' : '')} disabled={loading} id="btn-signup" onClick={submit}>{ t('Login') }</button>
            </div>
        </div>
    )
}

export default LoginAdditionalAuth;
